import type { UserRole } from "@/lib/types/auth.types"

export const STAFF_ROLES: UserRole[] = [
  "superadmin",
  "admin",
  "manager",
  "marketer",
  "finance",
  "non_essential",
  "creator",
]

const ALL_ROLES: UserRole[] = [...STAFF_ROLES, "customer"]

export function normalizeRole(value?: string | null): UserRole | null {
  if (!value) return null
  const normalized = value.toLowerCase().replace(/-/g, "_")
  return ALL_ROLES.includes(normalized as UserRole) ? (normalized as UserRole) : null
}

export function isStaffRole(value?: string | null): boolean {
  const role = normalizeRole(value)
  return role ? STAFF_ROLES.includes(role) : false
}
